import Colors from '@constants/Colors';
import { useEffect } from 'react';
import {
  useAnimatedStyle,
  useSharedValue,
  withSequence,
  withTiming,
} from 'react-native-reanimated';

const PULSE_TIME = 500; // Duration of one pulse in milliseconds

export default function useRaiseHandButtonAnimation() {
  const backgroundColor = useSharedValue<string>(Colors.dark.purple1opacity50); // Background color

  useEffect(() => {
    const startAnimation = () => {
      backgroundColor.value = withSequence(
        withTiming(Colors.dark.purple1, { duration: PULSE_TIME }),
        withTiming(Colors.dark.purple1opacity50, { duration: PULSE_TIME }),
        withTiming(Colors.dark.purple1, { duration: PULSE_TIME }),
        withTiming(Colors.dark.purple1opacity50, { duration: PULSE_TIME }),
      );
    };

    const interval = setInterval(() => {
      startAnimation();
    }, 10000); // Repeat every 10 seconds

    startAnimation(); // Start animation immediately on mount

    return () => {
      clearInterval(interval); // Clear interval on unmount
    };
  }, []);

  // Animated styles
  const animatedStyle = useAnimatedStyle(() => ({
    backgroundColor: backgroundColor.value,
  }));

  return { animatedStyle };
}
